
export const useUserDocumentSettings = defineStore(
  "/user/document/settings",
  () => {


    

    const allowInlineAnnotations = ref(false);


    const toggleInlineAnnotations = () => {
      allowInlineAnnotations.value = !allowInlineAnnotations.value;
    };

    return {
      allowInlineAnnotations,
      toggleInlineAnnotations,
    };
  }
);
